export default "__VITE_ASSET__DYVwFj_6__"